import { useCurrentStateAndParams } from '@uirouter/react';

import { useNamespaceQuery } from '@/react/kubernetes/namespaces/queries/useNamespaceQuery';

import { InlineLoader } from '@@/InlineLoader';
import { Widget } from '@@/Widget/Widget';
import { WidgetBody } from '@@/Widget';

import { YAMLInspector } from '../../components/YAMLInspector';
import { useNamespaceYAML } from '../queries/useNamespaceYAML';

export function NamespaceYAMLEditor() {
  const {
    params: { id: namespace, endpointId: environmentId },
  } = useCurrentStateAndParams();
  const namespaceData = useNamespaceQuery(environmentId, namespace);
  const isSystemNamespace = namespaceData.data?.IsSystem;

  const { data: fullNamespaceYaml, isLoading: isNamespaceYAMLLoading } =
    useNamespaceYAML(environmentId, namespace);

  if (isNamespaceYAMLLoading) {
    return (
      <Widget className="mx-4">
        <WidgetBody>
          <InlineLoader>Loading namespace YAML...</InlineLoader>
        </WidgetBody>
      </Widget>
    );
  }

  return (
    <Widget className="mx-4">
      <WidgetBody>
        <YAMLInspector
          identifier="namespace-yaml"
          data={fullNamespaceYaml || ''}
          authorised
          system={isSystemNamespace}
          hideMessage
          data-cy="namespace-yaml"
        />
      </WidgetBody>
    </Widget>
  );
}
